import { useSizeReferenceDisplay } from "@hooks/use-current-user";

function SizeReferenceMention() {
  const sizeReference = useSizeReferenceDisplay();

  return <span className="font-size-xs">{` ${sizeReference}`}</span>;
}

export default SizeReferenceMention;
